<mat-form-field>
    <mat-label>{{ label() }} ({{ defaultCulture }})</mat-label>
    <input
        matInput
        [ngModel]="value()"
        (ngModelChange)="value.set($event); updateLocale('en', $event)"
        required
        autocomplete="off"
        name="label"
    />
    <button type="button" mat-icon-button matSuffix (click)="toggleTranslation()">
        <mat-icon>translate</mat-icon>
    </button>
</mat-form-field>

@if (showTranslation()) {
    <div class="tranlations">
        @for (locale of locales(); track locale) {
            @if (locale !== defaultCulture) {
                <mat-form-field>
                    <mat-label>{{ locale }}</mat-label>
                    <input
                        matInput
                        [ngModel]="translations()[locale]"
                        (ngModelChange)="updateLocale(locale, $event)"
                        required
                        autocomplete="off"
                        name="label"
                    />
                </mat-form-field>
            }
        }
        @if (manageLocalesLink) {
            <a [routerLink]="manageLocalesLink" (click)="onManageLocalesClick()">Manage locales</a>
        }
    </div>
}
